import { transactionStatus } from "pages/transactions/constants";
import Avatar from "pages/_components/Avatar";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import { TransactionSign } from "pages/_components/TransactionCard";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { bool, func, shape, string } from "prop-types";
import React, { useContext, useState } from "react";
import * as i18n from "util/i18n";
import Image from "pages/_components/Image";

const ComexTransactionBody = (props) => {
    const { setShowMoreData, showMoreData, isDesktop } = props;
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, idTransactionStatus = "" } = transaction;
    const isPending = idTransactionStatus === transactionStatus.PENDING;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const {
        contactDestination = props.contactDestination,
        concept = props.concept,
        operationType = props.operationType,
        transferData = {},
    } = data;

    const {
        originAccountLabel = props.originAccountLabel,
        ownerName = props.ownerName,
        ownerCuit = props.ownerCuit,
        intermediary = props.intermediary,
        reason = props.reason,
        amount = props.amount,
        currency : foreignCurrency,
    } = transferData;

    const tagType =
        // eslint-disable-next-line no-nested-ternary
        transaction.idTransactionStatus === transactionStatus.FINISHED
            ? "tag-success"
            : transaction.idTransactionStatus === transactionStatus.FAILED ||
                transaction.idTransactionStatus === transactionStatus.CANCELLED
            ? "tag-error"
            : "tag-warning";

    return (
        <div className="ticket__body newpayment">
            <div className="ticket-header-info ">
                <div className="beneficiary">
                    <div className="avatar-name">
                        <Avatar
                            user={{
                                userFullName: contactDestination?.recipientName || "",
                                defaultAvatarId: 0,
                                email: contactDestination?.emailRecipient,
                            }}
                        />
                    </div>
                    <div className="user-info align-items-center">
                        <div className="small">{i18n.get("echecks.beneficiary")}</div>
                        <div className="large">{`${contactDestination?.recipientName}`}</div>
                    </div>
                </div>
                <div>
                    <CustomData
                        dataClass={`amount tag " ${tagType}`}
                        titleClass="text-right"
                        titleText="echecks.emit.amountField.label"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={foreignCurrency} quantity={amount.quantity} noCurrencyTranslation={true} />}
                    />
                </div>
            </div>
            <div className="view-more-data-button" id="element-to-ignore">
                <div className="ticket__divider inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <Button
                    aria-expanded={showMoreData ? "true" : "false"}
                    className="more-button"
                    label={buttonLabel}
                    bsStyle="link"
                    onClick={handleSeeMoreData}
                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                />
            </div>
            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                <div className="emissor-beneficiary">
                    <div className="emissor-data">
                        <h2>{i18n.get("echecks.emissor", "Emisor")}</h2>
                        <CustomData
                            titleText="mep.debitAccount.label"
                            titleTextType="I18N"
                            valueText={originAccountLabel}
                        />
                        <CustomData
                            titleText="comex.contact.recipientName.label"
                            titleTextType="I18N"
                            valueText={ownerName}
                        />
                        <CustomData titleText="mep.holder.cuit" titleTextType="I18N" valueText={ownerCuit} />
                    </div>
                    <div className="transaction-arrow">
                        <Image src="images/figma/icon/arrow-right.svg" className="icon-large" />
                    </div>
                    <div className="benefitiary-data">
                        <h2 className="">{i18n.get("echecks.beneficiary")}</h2>
                        <CustomData
                            titleText="comex.iban.label"
                            titleTextType="I18N"
                            valueText={contactDestination?.number}
                        />
                        <CustomData
                            titleText="comex.contact.recipientName.label"
                            titleTextType="I18N"
                            valueText={contactDestination?.recipientName}
                        />
                        <CustomData
                            titleText={intermediary ? "comex.bank.label" : ""}
                            titleTextType="I18N"
                            keepSpaceIfNotitle
                            valueText={intermediary}
                        />
                    </div>
                </div>
                <div className="ticket__divider divider_1 inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <div className="aditional-data">
                    <h2>{i18n.get("", "Datos adicionales")}</h2>
                    <CustomData titleText="comex.reason.label" titleTextType="I18N" valueText={reason} />
                    <CustomData
                        titleText="comex.concept.label"
                        titleTextType="I18N"
                        valueText={`comex.concept.others.${concept}.label`}
                        valueTextType="I18N"
                    />
                    <CustomData
                        titleText="comex.transfer.amount.label"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={foreignCurrency} quantity={amount.quantity} noCurrencyTranslation={true} />}
                    />

                    <CustomData
                        titleText="comex.transfer.operationType.label"
                        titleTextType="I18N"
                        valueText={`comex.transfer.${operationType}.label`}
                        valueTextType="I18N"
                    />
                </div>
                <TransactionSign
                    isSmall
                    creationTime
                    hasVaucher
                    isDesktop={isDesktop}
                    noDate={isPending}
                    showMoreData={showMoreData}
                    hasVoucherInPending
                />
            </div>
        </div>
    );
};

ComexTransactionBody.propTypes = {
    contactDestination: shape({}),
    selectedConcept: string,
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};

ComexTransactionBody.defaultProps = {
    contactDestination: null,
    selectedConcept: "",
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => {},
};

export default ComexTransactionBody;
